import React, { useState } from 'react';
import StudentForm from './StudentForm';
import TutorForm from './TutorForm';
import AdminForm from './AdminForm';

const AdminTab = () => {
  const [activeTab, setActiveTab] = useState('tutor');

  const tabs = [
    { id: 'tutor', label: 'TUTOR' },
    { id: 'student', label: 'STUDENT' },
    { id: 'administrator', label: 'ADMINISTRATOR' }
  ];

  const tabContent = {
    tutor: (
        <div className="p-6">
          <TutorForm/>
        </div>
    ),
    student: (
      <div className="p-6">
        <StudentForm />
      </div>
    ),
    administrator: (
      <div className="p-6">
      <AdminForm/>
      </div>
    )
  };

  return (
    <div className="min-h-screen bg-base-200 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-primary mb-2">User Registration</h1>
          {/* <p className="text-lg text-gray-600">Select your role to continue</p> */}
        </div>

        {/* Tabs */}
        <div className="tabs tabs-boxed justify-center mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab tab-lg ${activeTab === tab.id ? 'tab-active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="bg-base-100 rounded-box shadow-xl">
          {tabContent[activeTab]}
        </div>
      </div>
    </div>
  );
};

export default AdminTab;